import axios from 'axios';
import { getBaseUrl } from './helpers';
import { refreshToken } from './auth';

// API Endpoints
const GET_DIAGNOSTICS_CATEGORIES_ENDPOINT = `/building/api/diagnostic/categories/`;
const GET_PROCESSES_ENDPOINT = `/building/api/processes/`;

export const getDiagnosticsCategories = async (env, identifier) => {
  const BASE_URL = getBaseUrl(env);
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    const refreshed = await refreshToken(env);

    if (!refreshed) {
      return null;
    }

    authToken = refreshed.token;
  }

  try {
    const response = await axios.get(
      `${BASE_URL}${GET_DIAGNOSTICS_CATEGORIES_ENDPOINT}${identifier}/`,
      {
        headers: {
          Authorization: `JWT ${authToken}`,
          'Content-Type': 'application/json',
        },
      }
    );

    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      const refreshed = await refreshToken(env);

      if (!refreshed) {
        return null;
      }

      return getDiagnosticsCategories(env, identifier);
    }

    return Promise.reject(error.response?.data?.errors?.[0]?.message);
  }

}

export const getDiagnosticsDataPoints = async (env, apiLocation) => {
  const BASE_URL = getBaseUrl(env);
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    const refreshed = await refreshToken(env);

    if (!refreshed) {
      return null;
    }

    authToken = refreshed.token;
  }
  try {
    const response = await axios.get(
      `${BASE_URL}${apiLocation}`, 
      {
        headers: {
          Authorization: `JWT ${authToken}`,
          'Content-Type': 'application/json',
        },
    });

    return response.data;
    
  } catch (error) {
    if (error.response.status === 401) {
      const refreshed = await refreshToken(env);

      if (!refreshed) {
        return null;
      }
      return getDiagnosticsDataPoints(env, apiLocation);
    }
    return Promise.reject(error.response?.data?.errors?.[0]?.message);
  }
}

export const getDiagnosticsData = async (env, apiLocation, dataPoints = [], startTime, endTime) => {
  const BASE_URL = getBaseUrl(env);
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    const refreshed = await refreshToken(env);

    if (!refreshed) {
      return null
    }

    authToken = refreshed.token;
  }

  let API_ENDPOINT = `${BASE_URL}${apiLocation}?data_points=`;
  const filteredDataPointList = [];

  if (dataPoints.length > 0) {
    dataPoints.map((dataPoint) => {
      return filteredDataPointList.push(dataPoint);
    });

    API_ENDPOINT = `${API_ENDPOINT}${filteredDataPointList.join(',')}`;
  }

  API_ENDPOINT = `${API_ENDPOINT}&start_datetime=${startTime}&end_datetime=${endTime}`;


  try {
    const response = await axios.get(API_ENDPOINT, {
      headers: {
        Authorization: `JWT ${authToken}`,
        'Content-Type': 'application/json',
      }
    })
    return response.data;
    
  } catch (error) {

    if (error.response.status === 401) {
        const refreshed = await refreshToken(env);

        if (!refreshed) {
          return null
        }

        return getDiagnosticsData(env, apiLocation, dataPoints, startTime, endTime);
      }

      return Promise.reject(error.response?.data?.errors?.[0]?.message);
  }
}

export const getCSVData = async (env, building, category, startTime, endTime, interval, tags) => {
  const BASE_URL = getBaseUrl(env);
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    const refreshed = await refreshToken(env);

    if (!refreshed) {
      return null;
    }

    authToken = refreshed.token;
  }

  const API_ENDPOINT = `${BASE_URL}${GET_DIAGNOSTICS_CATEGORIES_ENDPOINT}${building}/${category}/data/export/`;

  try {
    const response = await axios.post(API_ENDPOINT, {
        identifier: building,
        categroy_slug: category,
        start_datetime: startTime,
        end_datetime: endTime,
        data_interval: interval,
        tags, 
      }, {
        headers: {
          'Authorization': `JWT ${authToken}`,
          'Content-Type': 'application/json',
        }
      })
    
    return response.data;

  } catch (error) {
    if (error.response.status === 401) {
        const refreshed = await refreshToken(env);

        if (!refreshed) {
          return null;
        }

        return getCSVData(env, building, category, startTime, endTime, interval, tags);
      }
      return Promise.reject(error.response.data.errors[0].message);
  }
}

export const fetchProcesses = async (env, building) => {
  const BASE_URL = getBaseUrl(env);
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    const refreshed = await refreshToken(env);

    if (!refreshed) {
      return null;
    }

    authToken = refreshed.token;
  }

  const API_ENDPOINT = `${BASE_URL}${GET_PROCESSES_ENDPOINT}${building}/`;

  try {
    const response = await axios.get(API_ENDPOINT, {
      headers: {
        Authorization: `JWT ${authToken}`,
        'Content-Type': 'application/json',
      },
    });

    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      const refreshed = await refreshToken(env);

      if (!refreshed) {
        return null;
      }

      return fetchProcesses(env, building);
    }

    return Promise.reject(error.response?.data?.errors?.[0]?.message);
  }
};

export const fetchNewMonitoringData = async (env, apiLocation, startTime, endTime, interval, dataContext) => { // Not Used
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    const refreshed = await refreshToken(env);

    if (!refreshed) {
      return null;
    }

    authToken = refreshed.token;
  }

  try {
    const response = await axios.post(
      apiLocation,
      {
        interval,
        end_datetime: endTime,
        start_datetime: startTime,
        data_point_context: dataContext,
      },
      {
        headers: {
          Authorization: `JWT ${authToken}`,
          'Content-Type': 'application/json',
        },
      }
    );

    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      const refreshed = await refreshToken(env);

      if (!refreshed) {
        return null;
      }

      return fetchNewMonitoringData(env, apiLocation, startTime, endTime, interval, dataContext);
    }

    return Promise.reject(error.response?.data?.errors?.[0]?.message);
  }
}

export const fetchNewMonitoringDataPoints = async (env, building) => { // Not Used
  const BASE_URL = getBaseUrl(env);
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    const refreshed = await refreshToken(env);

    if (!refreshed) {
      return null;
    }

    authToken = refreshed.token;
  }

  const API_ENDPOINT = `${BASE_URL}${GET_DIAGNOSTICS_CATEGORIES_ENDPOINT}${building}/default/data-points/`;

  try {
    const response = await axios.get(API_ENDPOINT, {
      headers: {
        Authorization: `JWT ${authToken}`,
        'Content-Type': 'application/json',
      },
    });

    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      const refreshed = await refreshToken(env);

      if (!refreshed) {
        return null;
      }

      return fetchNewMonitoringDataPoints(env, building);
    }

    return Promise.reject(error.response?.data?.errors?.[0]?.message);
  }
}

export const fetchNewCustomMonitoringData = async (env, building, process, start, end, dataPoints) => { // Not Used
  const BASE_URL = getBaseUrl(env);
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    const refreshed = await refreshToken(env);

    if (!refreshed) {
      return null;
    }

    authToken = refreshed.token;
  }

  const API_ENDPOINT = `${BASE_URL}${GET_PROCESSES_ENDPOINT}${building}/process/${process}/?start_datetime=${start}&end_datetime=${end}&data_points=${dataPoints}`;

  try {
    const response = await axios.get(API_ENDPOINT, {
      headers: {
        Authorization: `JWT ${authToken}`,
        'Content-Type': 'application/json',
      },
    });

    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      const refreshed = await refreshToken(env);

      if (!refreshed) {
        return null;
      }

      return fetchNewCustomMonitoringData(env, building, process, start, end, dataPoints);
    }

    return Promise.reject(error.response?.data?.errors?.[0]?.message);
  }
}
